import React from 'react';
import VerificationTab from './modules/VerificationTab';
import './CompanyVerificationPage.css';

function VerificationPageSkeleton() {
  return (
    <div className="company-verification-skeleton">
      <div className="company-verification-skeleton__sidebar">
        <span className="skeleton-block company-verification-skeleton__crumb" />
        {[...Array(4)].map((_, index) => (
          <span
            key={`verification-skeleton-filter-${index}`}
            className="skeleton-block company-verification-skeleton__filter"
          />
        ))}
      </div>
      <div className="company-verification-skeleton__content">
        <span className="skeleton-block company-verification-skeleton__line" />
        <span className="skeleton-block company-verification-skeleton__line company-verification-skeleton__line--short" />
        <div className="company-verification-skeleton__list">
          {[...Array(4)].map((_, index) => (
            <div
              key={`verification-skeleton-row-${index}`}
              className="company-verification-skeleton__row"
            >
              <span className="skeleton-block company-verification-skeleton__icon" />
              <div className="company-verification-skeleton__body">
                <span className="skeleton-block company-verification-skeleton__line" />
                <span className="skeleton-block company-verification-skeleton__line company-verification-skeleton__line--short" />
              </div>
              <span className="skeleton-block company-verification-skeleton__action" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function CompanyVerificationPage({
  company,
  canUploadDocuments = false,
  loading = false,
}) {
  const companyId = company?.id;
  const companyName =
    company?.razonSocial || company?.nombre || company?.name || 'Tu empresa';
  const showSkeleton = loading;

  return (
    <div className="company-verification-page">
      <header
        className="company-verification-heading"
        aria-labelledby="company-verification-title"
      >
        <p className="company-verification-kicker">{companyName}</p>
        <h1 id="company-verification-title">Verificación de empresa</h1>
        <p className="company-verification-subtitle">
          Administra y sube los documentos requeridos para validar tu cuenta.
        </p>
      </header>

      <section className="company-verification-shell" aria-label="Panel de verificación">
        {showSkeleton ? (
          <VerificationPageSkeleton />
        ) : (
          <VerificationTab companyId={companyId} canUpload={canUploadDocuments} />
        )}
      </section>
    </div>
  );
}
